export default "__VITE_ASSET__DwmADXoo__"